<template>
    <div class="ps">
        <div class="ps_top">
            <i class="el-icon-edit"></i>
            <div>账号管理>续费流水</div>
        </div>
        <div class="ps_search">
            <div class="search_box">
                <el-input class="" v-model="searchinput" placeholder="搜索邮箱号码"></el-input>
            </div>
            <div class="button_box">
                <el-button @click="resetting()">重置</el-button>
                <el-button @click="query()">查询</el-button>
            </div>
        </div>
        <div>
            <el-table
            :data="tableData"
            style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号">
                </el-table-column>
                <el-table-column
                    prop="memberEmail"
                    label="邮箱账号"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="payTime"
                    label="支付时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="payAmount"
                    label="支付金额">
                </el-table-column>
                <el-table-column
                    prop="payContent"
                    label="支付内容">
                </el-table-column>
            </el-table>
        </div>
        <div class="ps_pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                searchinput:'',
                tableData: [],
                page:{
                    pagesize:10,
                    pagescount:1,
                    totalElements:1,
                    currentPage:1
                },
            }
        },
        mounted(){
            this.getOrderList();
        },
        methods:{
            getOrderList(){
                this.$http.get(`/order/member?pageIndex=${this.page.currentPage}&&pageSize=${this.page.pagesize}${this.searchinput?'&&key='+this.searchinput:''}`).then((res) => {
                    if(res.code==200){
                        this.tableData=res.data.data;
                        this.page.currentPage=res.data.pageIndex;
                        this.page.totalElements=res.data.totalElements;
                    }
                }).catch((err) => {
                    
                });
            },
            handleCurrentChange(val){
                this.page.pagescount=val;
                this.page.currentPage=val;
                this.getOrderList()
            },
            handleSizeChange(val){
                this.page.pagesize=val;
                this.getOrderList()
            },
            //重置
            resetting(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.searchinput='';
                this.getOrderList()
            },
            //查询
            query(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.getOrderList()
            },
        }
    }
</script>

<style lang="less" scoped>
.ps{
    width: 100%;
    height: 100%;
    box-sizing: border-box ;
    background: #fff;
    min-height: 829px;
    padding: 10px 20px;
    .ps_top{
            width: 100%;
            height: 20px;
            display: flex;
            align-items: center;
            box-sizing: border-box
        }
    .ps_search{
        box-sizing: border-box;
        width:100%;
        height: 50px;
        border: 1px solid #d7d7d7;
        margin: 10px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0px;
        .search_box{
            box-sizing: border-box;
            padding-left: 20px;
            width: 300px;
        }
        .button_box{
            box-sizing: border-box;
            padding-right: 20px;
        }
    }
    .ps_pagination{
        width: 100%;
        height: 5%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: right;
    }
}
</style>